/* eslint-disable no-prototype-builtins */
<template>
  <div>
    <v-snackbar v-model="popup.visible" :color="popup.type" :timeout="3000" :top="'top'" :bottom="false"
      class="custom-snackbar">
      {{ popup.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="popup.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="bottomPopup.visible" :color="bottomPopup.type" :timeout="3000" :top="false" :bottom="'bottom'"
      class="custom-snackbar">{{ bottomPopup.text }}</v-snackbar>
    <v-dialog v-if="selectedLocation.nasid && selectedLocation.nasid > 0" v-model="showAdvancedSettings" fullscreen hide-overlay transition="dialog-bottom-transition" app>
      <AdvancedSettings v-bind:showAdvancedSettings="showAdvancedSettings" v-bind:advancedSettings="advancedSettings"
        v-on:save="SaveAdvancedSetting($event)" v-on:error="showAdvancedSettingsError($event)" v-on:close="
          showAdvancedSettings = false;
          GetAdvancedSettings();
        "></AdvancedSettings>
    </v-dialog>
    <v-dialog v-if="selectedLocation.nasid && selectedLocation.nasid > 0" v-model="planNPayOn" fullscreen hide-overlay transition="dialog-bottom-transition" app
      style="left: unset;width:640px;">
      <PlanAndPayment 
        :key="'planAndPayment_' + planNPayPage"
        v-bind:page="planNPayPage"
        v-bind:plans="dataPlanSettings"
        v-bind:selectedLocation="this.selectedLocation"
        v-bind:editUpi="editUpi" 
        v-bind:fromSettings="true"
        v-on:close="planNPayOn = false"></PlanAndPayment>
    </v-dialog>
    <v-tabs v-model="tab" color="#f26547" background-color="transparent" grow>
      <v-tab class="fs-14 fw-400 text-capitalize" style="    font-weight: 500;
    font-size: 16px;
    font-family: inherit;
    letter-spacing: normal;" @click="refreshUsage()">Usage</v-tab>
      <v-tab class="fs-14 fw-400 text-capitalize" style="    font-weight: 500;
    font-size: 16px;
    font-family: inherit;
    letter-spacing: normal;" @click="refreshCustomers()">Customers</v-tab>
      <v-tab v-if="selectedLocation.nasid && (couponOnlyFlowNasids.indexOf(selectedLocation.nasid) < 0)" class="fs-14 fw-400 text-capitalize"
        style="font-weight: 500;font-size: 16px;font-family: inherit;letter-spacing: normal;"
        @click="refreshSettings()">Settings</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
      <!-- Usage -->
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col style="text-align:center;justify-content:center;color:#999;">Guest WiFi Status:</v-col>
            <v-col style="text-align:center;justify-content:center;margin-left: 33px;">
              <span class="compact-bold" style="color:#68d391;    margin-left: -35px;"
                v-if="!nonPremium() && selectedLocation.connectionStatus == 1">
                <img src="~/img/icons/tick.png" style="width:18px; position: relative; bottom: -3px;margin-left:-15px;" />
                Working
              </span>
              <span class="compact-bold" style="color:#ff4444;"
                v-if="nonPremium() || selectedLocation.connectionStatus == 0" @click="$emit('troubleshoot', true)"
                key="'status'+reportData.connectionStatus">
                <img src="~/img/icons/tick.png" style="width:18px; position: relative; bottom: -3px;margin-left:-25px;" />
                Not-Working
              </span>
            </v-col>
          </v-row>
          <v-sheet elevation="2" style="margin:10px -15px 0px -15px;">
            <v-row>
              <v-col>
                <v-row>
                  <v-col style="text-align:center;">
                    <span class="pr-2 fw-800 text-uppercase" style="color:#48bb78;font-weight:bold;">User</span>
                    <v-tooltip bottom max-width="207" max-height="57">
                      <template v-slot:activator="{ on }">
                        <v-icon class="help-icon" v-on="on" style="position: relative; bottom: 2px;">mdi-help</v-icon>
                      </template>
                      <span>Total number of users connected to your Wi-Fi</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="text-align:center">
                    <v-card-title v-if="reportData.totalUsers <= 999"
                      style="color:#484848;font-size:3.6rem;padding-top:0px;justify-content:center"
                      @click="totalUserChart = true">
                      {{ reportData.totalUsers }}
                      <span class="report-card-data-unit" style="visibility:hidden;">MB</span>
                    </v-card-title>
                    <v-card-title v-if="reportData.totalUsers > 999"
                      style="color:#484848;font-size:3.6rem;padding-top:0px;justify-content:center"
                      @click="totalUserChart = true">
                      {{ parseFloat(reportData.totalUsers / 1000).toFixed(1) }}
                      <span class="report-card-data-unit">K</span>
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="text-right">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" depressed class="white text-capitalize"
                      style="margin-right:10px;font-weight:normal;color:#999; font-size:14px;letter-spacing:normal;">
                      <v-icon left dark style="margin-right:2px;color:#666;">mdi-calendar-blank</v-icon>
                      {{ reportData.userDuration }}
                      <v-icon right style="margin-left:5px;">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="
                        GetTotalUserinXDays(1);
                        reportData.userDuration = 'Today';
                      ">
                      <v-list-item-title>Today</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="
                        GetTotalUserinXDays(7);
                        reportData.userDuration = '7 days';
                      ">
                      <v-list-item-title>7 days</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="
                        GetTotalUserinXDays(30);
                        reportData.userDuration = 'Last Month';
                      ">
                      <v-list-item-title>Last Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-sheet>
          <v-sheet elevation="2" style="margin:10px -15px 0px -15px;height:145px;">
            <v-row>
              <v-col>
                <v-row>
                  <v-col style="text-align:center;">
                    <span class="pr-2 fw-800 text-uppercase" style="color:#214294;font-weight:bold;">Data Used</span>
                    <v-tooltip bottom max-width="207" max-height="57">
                      <template v-slot:activator="{ on }">
                        <v-icon style="margin-top:-3px;" class="help-icon" v-on="on">mdi-help</v-icon>
                      </template>
                      <span>Total data consumed by all users</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style>
                    <v-card-title
                      style="color:#484848;font-size:3.6rem;padding-top:0px;justify-content:center; margin-left: 5px !important; margin-top: -15px !important;">
                      {{ FormatData(reportData.totalDataUsed)[0] }}
                      <span
                        style="font-size:1rem;padding-top:32px;color:#999;">{{ FormatData(reportData.totalDataUsed)[1] }}</span>
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="text-right">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" depressed class="white text-capitalize"
                      style="margin-right:10px;font-weight:normal;color:#999; font-size:14px;letter-spacing:normal;text-align:center;">
                      <v-icon left dark style="margin-right:2px;color:#666;">mdi-calendar-blank</v-icon>
                      {{ reportData.dataDuration }}
                      <v-icon right style="margin-left:5px;">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="
                        GetTotalDataInXDays(1);
                        reportData.dataDuration = 'Today';
                      ">
                      <v-list-item-title>Today</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="
                        GetTotalDataInXDays(7);
                        reportData.dataDuration = '7 days';
                      ">
                      <v-list-item-title>7 days</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="
                        GetTotalDataInXDays(30);
                        reportData.dataDuration = 'Last Month';
                      ">
                      <v-list-item-title>Last Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-sheet>
          <div v-if="nonPremium()"
            style="border:solid 1px red;margin-left:-5px;width:100%;background-color:rgba(255,255,255,0.9);display:block;height:85px;position:absolute;top:10px;text-align:center;">
            <div style="display:block;position:relative;top:5px;">
              <img style="width:35;height:35px;" src="~/img/locked.svg" />
              <span style="display:block;font-weight:bold;font-size:12px;margin-top:-3px">Premium Feature
                <br/><a @click="GoToPaymentPage()">PAY TO UPGRADE</a>
              </span>       
            </div>
          </div>
        </v-container>
      </v-tab-item>
      <!-- Customers -->
      <v-tab-item>
        <v-container class="customer-container" style="padding:0 !important;">
          <section class="pb-3 px-1">
            <v-col class="text-right py-0 px-0">
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" depressed class="white text-capitalize"
                    style="margin-right:10px;font-weight:normal;color:#999;font-size:0.75rem;letter-spacing:normal;">
                    <v-icon left dark style="margin-right:2px;color:#666;font-size:1rem;">mdi-calendar-blank</v-icon>
                    {{ cumulatedData.text }}
                    <v-icon right style="margin-left:5px;">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title @click="updateCumuilativeData({text: 'Today'})" style="font-size:0.75rem;">Today</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title @click="updateCumuilativeData({text: '7 days'})" style="font-size:0.75rem;">7 days</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title  @click="updateCumuilativeData({text: 'Last 30 days'})" style="font-size:0.75rem;">Last Month</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <div style="display: flex; justify-content: space-between;">
              <v-card max-width="155" class="bg-green boxshadow">
                <v-card-text class="text-capitalize text-center">
                  <p style="font-size:0.875rem;font-weight:700; width: 6rem" class="mb-0">
                    Total Earnings
                  </p>
                  <p style="font-size:x-large;font-weight:700;padding-top:0.125rem" class="mb-0">
                    ₹{{this.cumulatedData.earning}}
                  </p>
                </v-card-text>
              </v-card>
              <v-card max-width="155" class="ml-3 boxshadow">
                <v-card-text class="text-capitalize text-center">
                  <p style="font-size:0.875rem;font-weight:700;width: 6rem" class="mb-0">
                    Total Users
                  </p>
                  <p style="font-size:x-large;font-weight:700;padding-top:0.125rem" class="mb-0">
                    {{this.cumulatedData.requests}}
                  </p>
                </v-card-text>
              </v-card>
            </div>
          </section>
          <div style="text-align:center; margin-bottom: 1rem;">
            <v-btn style="text-transform:none;background:#f06b69;color:white" 
             @click="planNPayMethod({ page: 'send-coupon'})">
              Send Coupon
            </v-btn>
          </div>
          <div class="header">
            <ul style="">
              <li class="customer-record"> 
                <span>Mobile</span>
                <span>Date</span>
                <span>Plan</span>
                <span>Payment</span>
                <span style="color:transparent">Payment</span>
              </li>
            </ul>
          </div>
          <CustomerPopup v-if="customerPopup.user"
            ref="'customerPopup_' + customerPopup.type"
            v-bind:popupData="customerPopup"
            v-bind:selectedLocation="selectedLocation"
            @refresh-registered-users="GetUsers()"
            @closed="customerPopup.user = null"
          ></CustomerPopup>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-expansion-panel v-if="pendingRegisterUser && pendingRegisterUser.length > 0">
            <v-expansion-panel-header style="font-size:12px;font-weight:700;">Pending ({{
                pendingRegisterUser.length
              }})</v-expansion-panel-header>
            <v-expansion-panel-content style="padding: 0 0.5rem">
              <div class="pending-div" style="margin:0 -1rem">
                <ul style="padding-left:0">
                  <li class="customer-record" style="" v-for="(user, index) in pendingRegisterUser" :key="index"
                    @click.stop="customerPopup={user:user, type: 'pending'}">
                    <span>
                      <strong>{{ user.mobile }}</strong>
                    </span>
                    <span>{{dateFormat(user.planStartTime).substring(0, 6)}}</span>
                    <strong>{{ dataFormat(1024 * user.dataLimit*1024) }}/{{ timeFormat(user.timePlan)}}</strong>
                    <span v-if="user.charges">{{"₹ " + user.charges}}</span>
                    <span v-if="!user.charges">NA</span>
                    <span>
                      <v-btn x-small style="background:#f06b69;color:white"  @click.stop="customerPopup = {user: user, type: 'pending'}">
                        Allow
                      </v-btn>
                    </span>
                  </li>
                  <hr style="margin:0 -1.5rem;" />
                </ul>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="couponUsers && couponUsers.length > 0">
            <v-expansion-panel-header style="font-size:12px;font-weight:700;">Issued Coupons ({{
                couponUsers.length
              }})</v-expansion-panel-header>
            <v-expansion-panel-content style="padding: 0 0.5rem">
              <div class="pending-div" style="margin:0 -1rem">
                <ul style="padding-left:0">
                  <li class="customer-record" style="" v-for="(user, index) in couponUsers" :key="index"
                    @click.stop="customerPopup = {user: user, type: 'issued-coupon'}">
                    <span>
                      <strong>unused</strong>
                    </span>
                    <span>{{dateFormat(user.planStartTime).substring(0, 6)}}</span>
                    <strong>{{ dataFormat(1024 * user.dataLimit*1024) }}/{{ timeFormat(user.timePlan)}}</strong>
                    <span v-if="user.charges">{{"₹ " + user.charges}}</span>
                    <span v-if="!user.charges">NA</span>
                    <span></span>
                  </li>
                  
                  <hr style="margin:0 -1.5rem;" />
                </ul>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="doneRegisteredUser && doneRegisteredUser.length > 0">
            <v-expansion-panel-header style="font-size:12px;font-weight:700;">Done ({{
                doneRegisteredUser.length
              }})</v-expansion-panel-header>
            <v-expansion-panel-content style="padding: 0 0.5rem">
              <div class="done-div" style="margin:0 -1rem">
                <ul style="padding-left:0">
                  <li class="customer-record" @click.stop="customerPopup = {user: user, type: 'done'}"
                    v-for="(user,index) in doneRegisteredUser" v-bind:key="index">
                    <span><strong>{{ user.mobile }}</strong></span>
                    <span>{{ dateFormat(user.planStartTime).substring(0, 6) }}</span>
                    <strong>{{ dataFormat(1024 * user.dataLimit*1024) }}/{{ timeFormat(user.timePlan)}}</strong>
                    <span v-if="user.charges">{{"₹ " + user.charges}}</span>
                    <span v-if="!user.charges">NA</span>
                    <span>
                      <img src="~/img/icons/active.svg" style="vertical-align:middle" v-if="user.authState && user.otpExpiryTime > (new Date())"/>
                      <img src="~/img/icons/expired.svg" style="vertical-align:middle" v-else-if="user.authState && user.otpExpiryTime < (new Date())"/>
                      <img src="~/img/icons/disconnected.svg" style="vertical-align:middle" v-else/>
                    </span>
                  </li>
                  <hr style="margin:0 -1.5rem;" />
                </ul>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      
          
        </v-container>
      </v-tab-item>
      <!-- Settings -->
      <v-tab-item v-if="selectedLocation.nasid && (couponOnlyFlowNasids.indexOf(selectedLocation.nasid) < 0)">
        <v-container style="padding: 18px;">
          <div>
            <p class="fs-14 compact-bold">
              Language Preference
              <v-tooltip left max-width="207">
                <template v-slot:activator="{ on }">
                  <v-icon class="help-icon" v-on="on" style="float:right;">mdi-help</v-icon>
                </template>
                <span>Language for your Wi-Fi login pages</span>
              </v-tooltip>
            </p>
            <v-radio-group v-model="basicSettings.ex7" row>
              <v-radio label="English" color="success" value="en" class="fs-12 compact"></v-radio>
              <v-radio label="Hindi" color="success" value="hi" class="fs-12 compact"></v-radio>
              <v-radio label="Telugu" color="success" value="te" class="fs-12 compact"></v-radio>
            </v-radio-group>
          </div>
          <div>
            <p class="fs-14 mb-3 compact-bold">WiFi Name</p>
            <v-text-field label="WiFi Name" v-model="basicSettings.ssid" single-line :maxlength="24" type="text" :rules="[
                () => !!basicSettings.ssid || 'Guest Wi-Fi name cannot be blank',
                () =>
                    (!!basicSettings.ssid && basicSettings.ssid.length <= 24) ||
                    'Guest Wi-Fi name cannot exceed 24 characters',
              ]" counter="24" class="fs-14 pt-0 compact"></v-text-field>
          </div>
          <div>
            <span class="fs-14 fw-700 mb-3 compact-bold" style="line-height:24px;margin-bottom:10px;">Password
              Protected</span>
            <v-tooltip left max-width="207">
              <template v-slot:activator="{ on }">
                <v-switch v-model="basicSettings.ssidPasswordEnabled" label color="success" :value="true" hide-details
                  style="float:right;margin-top:0px;margin-right:10px;" @change="showPasswordWarning()" dense>
                </v-switch>
                <v-icon class="help-icon" v-on="on" style="float:right;position: relative;bottom:0px;margin-top:5px;">
                  mdi-help</v-icon>
              </template>
              <span>Set a password on your WiFI SSID</span>
            </v-tooltip>
            <v-text-field :disabled="!basicSettings.ssidPasswordEnabled" label v-model="basicSettings.ssidPassword"
              single-line :maxlength="10" :rules="[
                () => (!!basicSettings.ssidPassword && !!basicSettings.ssidPasswordEnabled ) || 'Guest Wi-Fi password cannot be blank. Disable to remove password.',
                () =>
                    (!!basicSettings.ssidPassword && basicSettings.ssidPassword.length <= 10) ||
                    'Guest Wi-Fi password cannot exceed 10 characters',
              ]" counter="10" class="fs-14 pt-0 compact wifi-password"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"></v-text-field>
          </div>
          <!-- Max Data Usage per day on Router -->
          <div>
            <span class="fs-14 fw-700 mb-3 compact-bold" style="line-height:24px;padding-top:-10px;margin-bottom:10px;">
              <v-icon height="24px" aspect-ratio="1" width="24px"
                style="display:inline-block;position: relative; top: -5px;margin-right:10px">mdi-router-wireless
              </v-icon>Max Data usage a day
            </span>
            <v-tooltip left max-width="207">
              <template v-slot:activator="{ on }">
                <v-icon class="help-icon" v-on="on" style="float:right;position: relative;bottom:-10px;">mdi-help
                </v-icon>
              </template>
              <span>Max data usage a day.</span>
            </v-tooltip>
            <div style="display: grid;grid-template-columns: 60px auto;margin-top:15px">
              <v-subheader class="pl-0" style="position: relative; bottom: 10px;">
                <span class="green-hint"
                  style="font-size:10px;padding:1px 2px 1px 2px;">{{ nasDatalimitLabels[nasDataLimit] }}</span>
              </v-subheader>
              <v-slider id="nasDataLimit" v-model="nasDataLimit" :tick-labels="nasDatalimitLabels" :max="12" :min="0"
                step="1" tick-size="4" color="success" track-color="#999999" dense>
                <template v-slot:thumb-label="props">
                  {{
                  nasDatalimitLabels[props.value]
                  }}
                </template>
              </v-slider>
            </div>
          </div>
          <!-- Max Data Usage per day/session -->
          <div v-if="false">
            <span class="fs-14 fw-700 mb-3 compact-bold" style="line-height:24px;padding-top:-10px;margin-bottom:10px;">
              <v-img height="24px" aspect-ratio="1" width="24px" src="~/img/icons/data.svg"
                style="display:inline-block;position: relative; bottom: -5px;margin-right:10px"></v-img>Maximum Data a
              user can use in a day
            </span>
            <v-tooltip left max-width="207">
              <template v-slot:activator="{ on }">
                <v-icon class="help-icon" v-on="on" style="float:right;position: relative;bottom:-10px;">mdi-help
                </v-icon>
              </template>
              <span>Maximum data a user can use in a day.</span>
            </v-tooltip>
            <div style="display: grid;grid-template-columns: 60px auto;margin-top:15px">
              <v-subheader class="pl-0" style="position: relative; bottom: 10px;">
                <span class="green-hint"
                  style="font-size:10px;padding:1px 2px 1px 2px;">{{ datalimitLabels[dataLimit] }}</span>
                <span v-if="basicSettings.unlimited" class="green-hint" style="font-size:10px;padding:1px 2px 1px 2px;">
                  Unlimited
                </span>
              </v-subheader>
              <v-slider id="dataLimit" v-model="dataLimit" :tick-labels="datalimitLabels" :max="12" :min="0" step="1"
                tick-size="4" color="success" track-color="#999999" dense>
                <template v-slot:thumb-label="props">
                  {{
                  datalimitLabels[props.value]
                  }}
                </template>
              </v-slider>
            </div>
          </div>
          <!-- Session Time Out -->
          <div style="padding-top:6px;" v-if="false">
            <v-icon>mdi-access_alarm</v-icon>
            <span class="fs-14 fw-700 compact-bold">
              <v-icon style="padding-right:10px;">mdi-timer-outline</v-icon>Maximum time for a session
              <v-tooltip left max-width="207">
                <template v-slot:activator="{ on }">
                  <v-icon class="help-icon" v-on="on" style="float: right;position: relative;margin-top: 3px;">mdi-help
                  </v-icon>
                </template>
                <span>Maximum time for which a user can connect to your Wi-Fi</span>
              </v-tooltip>
            </span>
            <div style="display: grid;grid-template-columns: 60px auto;padding-top:15px">
              <v-subheader class="pl-0" style="position: relative; bottom: 10px;">
                <span class="green-hint"
                  style="font-size:10px;padding:1px 2px 1px 2px;">{{ sessionLabels[sessionTimeOut] }}</span>
              </v-subheader>
              <v-slider id="timeout" v-model="sessionTimeOut" :tick-labels="sessionLabels" :max="13" :min="0" step="1"
                tick-size="4" color="success" track-color="#999999" dense>
                <template v-slot:thumb-label="props">
                  {{
                  sessionLabels[props.value]
                  }}
                </template>
              </v-slider>
            </div>
          </div>
          <!-- Devices per user -->
          <div style="margin-top:-10px" v-if="false">
            <v-icon>mdi-stay_primary_portrait</v-icon>
            <p class="fs-14 fw-700 compact-bold">
              <v-icon style="padding-right:10px;">mdi-cellphone</v-icon>No. of
              Devices / User
              <v-tooltip left max-width="207">
                <template v-slot:activator="{ on }">
                  <v-icon class="help-icon" v-on="on" style="float:right;">mdi-help</v-icon>
                </template>
                <span>
                  Maximum number of devices one user can connect to your
                  Wi-Fi
                </span>
              </v-tooltip>
            </p>
            <div style="display: grid;grid-template-columns: 58px auto;">
              <v-subheader class="pl-0" style="position: relative; bottom: 10px;">
                <span class="green-hint"
                  style="font-size:10px;padding:1px 2px 1px 2px;">{{ basicSettings.devicesPerUser }}</span>
              </v-subheader>
              <v-slider v-model="basicSettings.devicesPerUser" color="success" track-color="#999999" min="1" max="100"
                thumb-label></v-slider>
            </div>
          </div>
          <v-sheet @click="planNPayMethod({page: 'plans'})" style="margin-top:25px">
            <div class="py-4 pl-2 pr-0">
              <span style="font-weight:bold; font-size: 18px;">Manage Data Plans</span>
              <v-icon style="color:blue;float:right;position:relative;margin-right: -5px;">mdi-chevron-right</v-icon>
            </div>
          </v-sheet>
          <v-sheet @click="planNPayMethod({page: 'payment', editUpi: true})">
            <div class="py-4 pl-2 pr-0">
              <span style="font-weight:bold; font-size: 18px;">Manage Payment Modes</span>
              <v-icon style="color:blue;float:right;position:relative;margin-right: -5px;">mdi-chevron-right</v-icon>
            </div>
          </v-sheet>
          <v-sheet @click="
              showAdvancedSettings = true;
              GetAdvancedSettings();
            " style="margin-top:25px">
            <div class="py-4 pl-2 pr-0">
              <span style="font-weight:bold; font-size: 18px;">Advanced Settings</span>
              <v-icon style="color:blue;float:right;position:relative;margin-right: -5px;">mdi-chevron-right</v-icon>
            </div>
          </v-sheet>
          <div>
            <v-tooltip left max-width="207">
              <template v-slot:activator="{ on }">
                <v-icon class="help-icon" v-on="on" style="float: right;position: relative;margin-top: 8px;">mdi-help
                </v-icon>
              </template>
              <span>Guests will be able to automatically log in for 30 days.</span>
            </v-tooltip>
            <v-switch v-model="basicSettings.autoLogin" label="Auto Login" color="success" value="yes" hide-details
              style="float:right;margin-top:0px;margin-right:30px;" dense></v-switch>
          </div>
          <div class="pb-12" style="margin-bottom:60px">
            <v-btn :disabled="(!basicSettings.ssidPassword && basicSettings.ssidPasswordEnabled)" id="submit"
              width="100%" height="48" @click="saveConfig()">Save</v-btn>
          </div>
          <div v-if="nonPremium()"
            style="border:solid 1px red;margin-left:-5px;width:100%;background-color:rgba(255,255,255,0.9);display:block;height:470px;position:absolute;top:260px;text-align:center;">
            <div style="display:block;position:relative;top:100px">
              <img src="~/img/locked.svg" />
              <span style="display:block;font-weight:bold;font-size:22px">Premium Feature</span>
              <v-card height="55px" width="100%" color="#f3f3f3" class="upgrade-banner">
                <v-row>
                  <v-col class="upgrade-banner-text-col">
                    <ul class="upgrade-banner-text">
                      <li>- Track your customers</li>
                      <li>- Grow you business</li>
                    </ul>
                  </v-col>
                  <v-col class="upgrade-banner-cta-col">
                    <v-btn class="upgrade-banner-cta" color="#214294" style="color:white" @click="GoToPaymentPage()">PAY TO UPGRADE</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="showPlans" fullscreen hide-overlay transition="dialog-bottom-transition">
      <Plans v-bind:location="selectedLocation" v-bind:view="view" @close="showPlans = false"></Plans>
    </v-dialog>
    <v-dialog v-model="showPasswordPopup" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline" style="font-weight:bold;font-size:18px !important">Not Recommended</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">If you enable this, your customers will sign in using phone number and
                password both.</v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray grey" text @click="showPasswordPopup = false;basicSettings.ssidPasswordEnabled = false;">
            Cancel</v-btn>
          <v-btn class="primary" id="submit" color="white darken-1" text
            @click="showPasswordPopup = false;basicSettings.ssidPasswordEnabled = true;">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDataSettingWarning" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline" style="font-weight:bold;font-size:18px !important">Error</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4" style="color:grey">Setting for "Max Data usage a Day" cannot be less than
                setting for "Maximum Data a user can use in a day".</v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" id="submit" color="white darken-1" text @click="showDataSettingWarning = false;">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import async from "async";
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";
import AdvancedSettings from "./AdvancedSettings";
import CustomerPopup from "./CustomerPopup";
import Plans from "./../common/Plans";
import PlanAndPayment from "./PlanAndPayment";
import WIOM_APIS from './../../utils/wiom-apis';
import Model from './models/Settings';

export default {
  name: "BasicSettings",
  props: ["storeData", "selectedLocation", "settingId", "selectTab"],
  components: {
    AdvancedSettings,
    CustomerPopup,
    Plans,
    PlanAndPayment
  },
  data: function() {
    return Model;
  },
  methods: {
    nonPremium: function() {
      if (this.storeData == null || this.storeData.length < 1) return false;
      if (
        this.selectedLocation.subscription == null ||
        this.selectedLocation.subscription.active != true
      )
        return true;
      return false;
    },
    FormatData: function(data) {
      if (!data)
        //0
        return [0, "MB"];
      else {
        if (data >= 0 && data <= 999) {
          //1
          return [parseInt(data), "MB"];
        } else {
          if (data > 999 && data <= 9999) {
            //2
            return [parseInt((data / 1000).toFixed(1)), "GB"];
          } else {
            if (data > 9999 && data <= 99999) {
              //3
              return [parseInt((data / 1000).toFixed(1)), "GB"];
            } else {
              if (data >= 99999 && data <= 999999) {
                //4
                if (
                  (data / 1000).toFixed(1) -
                    parseInt((data / 1000).toFixed(1)) <=
                  0.5
                )
                  return [parseInt(Math.floor((data / 1000).toFixed(1))), "GB"];
                else
                  return [parseInt(Math.ceil((data / 1000).toFixed(1))), "GB"];
              } else {
                return [Math.ceil((data / (1000 * 1000)).toFixed(1)), "TB"];
              }
            }
          }
        }
      }
    },
    resetAdvancedSettingsData: function() {
      this.advancedSettings = {
        settingId: this.settingId,
        vipNumber: [],
        whitelistNumber: [],
        blockNumber: [],
        vipMac: [],
        whitelistMac: [],
        blacklistMac: []
      };
      this.advancedConfiguration = {
        settingId: this.settingId,
        advanceConfigs: {
          AUTH_TYPE: {
            configType: 1,
            parameters: ["0"],
            value: null
          },
          ROUTER_SPLASH_IMAGE: {
            configType: 2,
            parameters: [""],
            value: null
          },
          LOGIN_PAGE_IMAGE: {
            configType: 3,
            parameters: [""],
            value: null
          },
          LANDING_PAGE_CONFIG: {
            configType: 4,
            parameters: [""],
            value: null
          },
          TEMPLATE_CONFIG: {
            configType: 5,
            parameters: [""],
            value: null
          },
          SHINE_PLUS_ACTIVATION: {
            configType: 6,
            parameters: [""],
            value: null
          },
          DEVICE_ACTIVATION: {
            configType: 7,
            parameters: [""],
            value: null
          },
          OPERATING_HOURS: {
            configType: 8,
            parameters: null,
            value: null
          },
          FACEBOOK_PAGE: {
            configType: 9,
            parameters: [""],
            value: null
          },
          FACEBOOK_CHECKIN: {
            configType: 11,
            parameters: [""],
            value: null
          },
          HIDE_QUESTION: {
            configType: 12,
            parameters: ["0"],
            value: null
          },
          NO_OF_DEVICES_PER_USER: {
            configType: 13,
            parameters: [""],
            value: null
          },
          GLOBAL_OTP: {
            configType: 14,
            parameters: null,
            value: null
          },
          AUTO_LOGIN_SPAN: {
            configType: 15,
            parameters: [""],
            value: null
          },
          VALIDATE_USER_LOGIN: {
            configType: 16,
            parameters: [""],
            value: null
          },
          DATA_VOUCHER_DETAILS: {
            configType: 17,
            parameters: [""],
            value: null
          },
          OVERRIDE_OTP: {
            configType: 18,
            parameters: [""],
            value: null
          },
          LANGUAGE_PREFERENCE: {
            configType: 19,
            parameters: [""],
            value: null
          }
        }
      };
    },
    dateFormat: function(str) {
      let dateTime = new Date(str);
      return dateTime.toGMTString().substring(5, 16);
    },
    timeFromDatTime: function(str) {
      let dateTime = new Date(str);
      let time = dateTime.toTimeString();
      time = time.substr(0, time.lastIndexOf(":"));
      return time;
    },
    SetUserBasicConfig: function(callback) {
      WIOM_APIS.setUserBasicConfig({
            settingId: this.settingId,
            userGroups: [
              {
                basicConfigs: {
                  CHILLISPOT_MAX_TOTAL_OCTETS: {
                    value: this.datalimitValues[this.dataLimit],
                    configType: parseInt(this.basicSettings.maxDataConfigType)
                  },
                  SESSION_TIMEOUT: {
                    value: this.sessionValues[this.sessionTimeOut],
                    configType: this.basicSettings.sessionConfigType
                  }
                },
                groupId: 0
              }
            ]
          })
        .then(response => {
          response = null;
          console.log("saved basic config", response);
          callback(null, response);
        }).catch(function (error) {
          console.log("Error in API Call", error);
          callback(error, null);
        });
    },
    SetAdvancedConfiguration: function(callback) {
      if (
        this.basicSettings.autoLogin &&
        this.basicSettings.autoLogin == "yes"
      ) {
        this.advancedConfiguration.advanceConfigs[
          "SHINE_PLUS_ACTIVATION"
        ].parameters = ["1"];
        this.advancedConfiguration.advanceConfigs[
          "AUTO_LOGIN_SPAN"
        ].parameters = ["30"];
      } else {
        this.advancedConfiguration.advanceConfigs[
          "SHINE_PLUS_ACTIVATION"
        ].parameters = ["0"];
        this.advancedConfiguration.advanceConfigs[
          "AUTO_LOGIN_SPAN"
        ].parameters = [""];
      }
      this.advancedConfiguration.advanceConfigs[
        "NO_OF_DEVICES_PER_USER"
      ].parameters[0] = this.basicSettings.devicesPerUser;

      this.advancedConfiguration.advanceConfigs[
        "LANGUAGE_PREFERENCE"
      ].parameters[0] = this.basicSettings.ex7;
      this.advancedConfiguration.advanceConfigs[
        "NAS_DAILY_DATA_LIMIT"
      ].parameters[0] = this.nasDatalimitValues[this.nasDataLimit];

      WIOM_APIS.setAdvanceConfiguration(this.advancedConfiguration)
        .then(response => {
          response = null;
          console.log("set advanced config", response);
          callback(null, response);
        }).catch(function (error) {
          console.log("Error in API Call", error);
          callback(error, null);
        });
    },
    SaveAdvancedSetting: function() {
      let that = this;
      this.SaveAdvancedSettings(function(err, res) {
        if (!err && res) {
          that.popup.type = "success";
          that.popup.text = "Advanced Settings Saved";
          that.popup.visible = true;
        } else {
          that.popup.type = "error";
          that.popup.text = "Error Saving Advanced Settings";
          that.popup.visible = true;
        }
      });
    },
    SaveAdvancedSettings: function(callback) {
      var nasid = this.selectedLocation.nasid;
      var data = {
        VIP_LIST: {},
        MAC_WHITELISTING: {},
        MAC_BLACKLISTING: {},
        BLOCKED_LIST: {},
        WHITE_LIST: {},
        SSID: {},
        SSID_PASSWORD: {}
      };
      this.advancedSettings.vipNumber.forEach(element => {
        data.VIP_LIST[element.number] = element.name;
      });
      this.advancedSettings.blockNumber.forEach(element => {
        data.BLOCKED_LIST[element.number] = element.name;
      });
      this.advancedSettings.whitelistNumber.forEach(element => {
        data.WHITE_LIST[element.number] = element.name;
      });
      this.advancedSettings.whitelistMac.forEach(element => {
        data.MAC_WHITELISTING[element.mac] = element.name;
      });
      this.advancedSettings.blacklistMac.forEach(element => {
        data.MAC_BLACKLISTING[element.mac] = element.name;
      });
      if (this.basicSettings.ssid == null || this.basicSettings.ssid == "")
        data.SSID["i2e1"] = "Free_Wi-Fi";
      else data.SSID["i2e1"] = this.basicSettings.ssid;
      if (
        this.basicSettings.ssidPassword == null ||
        this.basicSettings.ssidPassword == ""
      )
        data.SSID_PASSWORD["i2e1"] = "";
      else data.SSID_PASSWORD["i2e1"] = this.basicSettings.ssidPassword;
      axios
        .post(
          "/Client/SaveListChecks?nasid=" +
            nasid +
            "&i2e1-admin-token=" +
            helper.getCookie("token") +
            "&i2e1-admin-view-token=" +
            helper.getCookie("token"),
          {
            accessList: data
          }
        )
        .then(response => {
          console.log("saved lists", response);
          this.showAdvancedSettings = false;
          callback(null, response);
        }).catch(function (error) {
          console.log("Error in API Call", error);
          callback(error, null);
        });
    },
    GetDataPlanSettings: function() {      
      var nasid = this.selectedLocation.nasid;
      if (nasid)
      WIOM_APIS.getPlans(nasid).then(response => {
        this.dataPlanSettings = response.data;
      });
    },
    GetAdvancedSettings: function() {
      this.resetAdvancedSettingsData();
      var nasid = this.selectedLocation.nasid;
      WIOM_APIS.getAdvanceConfiguration(this.settingId)
      .then(response => {
          //console.log("get advanced settings");
          this.advancedConfiguration.advanceConfigs = response.data;
          //console.log();
          this.basicSettings.devicesPerUser = this.advancedConfiguration.advanceConfigs[
            "NO_OF_DEVICES_PER_USER"
          ].parameters[0];
          if (
            this.advancedConfiguration.advanceConfigs["SHINE_PLUS_ACTIVATION"]
              .parameters[0] == "1" &&
            (this.advancedConfiguration.advanceConfigs["AUTO_LOGIN_SPAN"]
              .parameters[0] != "" ||
              this.advancedConfiguration.advanceConfigs["AUTO_LOGIN_SPAN"]
                .parameters[0] != "0")
          )
            this.basicSettings.autoLogin = "yes";
          else this.basicSettings.autoLogin = "";

          if (
            this.advancedConfiguration.advanceConfigs["NAS_DAILY_DATA_LIMIT"]
              .parameters[0] == null ||
            this.advancedConfiguration.advanceConfigs["NAS_DAILY_DATA_LIMIT"]
              .parameters[0] == ""
          ) {
            this.nasDataLimit = 12;
          } else {
            this.nasDataLimit = this.getNasDatalimitIndex(
              response.data.NAS_DAILY_DATA_LIMIT.parameters[0]
            );
          }

          this.basicSettings.ex7 = this.advancedConfiguration.advanceConfigs[
            "LANGUAGE_PREFERENCE"
          ].parameters[0];
          if (this.basicSettings.ex7 == "") this.basicSettings.ex7 = "en";
          if (this.nonPremium()) {
            this.dataLimit = 12;
            this.basicSettings.ex7 == "en";
            this.basicSettings.autoLogin = "";
            this.basicSettings.devicesPerUser = "1";
            this.sessionTimeOut = 9;
          }
        });
      axios
        .get(
          "/Client/GetListChecks?nasid=" +
            nasid +
            "&i2e1-admin-token=" +
            helper.getCookie("token") +
            "&i2e1-admin-view-token=" +
            helper.getCookie("token")
        )
        .then(response => {
          //console.log("get advanced settings");
          for (const prop in response.data.data) {
            // eslint-disable-next-line no-prototype-builtins
            if (response.data.data.hasOwnProperty(prop)) {
              for (var key in response.data.data[prop]) {
                // eslint-disable-next-line no-prototype-builtins
                if (response.data.data[prop].hasOwnProperty(key)) {
                  switch (prop) {
                    case "VIP_LIST":
                      this.advancedSettings.vipNumber.push({
                        number: key,
                        name: response.data.data[prop][key]
                      });
                      break;
                    case "WHITE_LIST":
                      this.advancedSettings.whitelistNumber.push({
                        number: key,
                        name: response.data.data[prop][key]
                      });
                      break;
                    case "BLOCKED_LIST":
                      this.advancedSettings.blockNumber.push({
                        number: key,
                        name: response.data.data[prop][key]
                      });
                      break;
                    case "MAC_WHITELISTING":
                      this.advancedSettings.whitelistMac.push({
                        mac: key,
                        name: response.data.data[prop][key]
                      });
                      break;
                    case "MAC_BLACKLISTING":
                      this.advancedSettings.blacklistMac.push({
                        mac: key,
                        name: response.data.data[prop][key]
                      });
                      break;
                    case "SSID":
                      this.basicSettings.ssid =
                        response.data.data[prop]["i2e1"];
                      break;
                    case "SSID_PASSWORD":
                      this.basicSettings.ssidPassword = response.data.data[
                        prop
                      ]["i2e1"]
                        ? response.data.data[prop]["i2e1"]
                        : "";
                      if (this.basicSettings.ssidPassword == "")
                        this.basicSettings.ssidPasswordEnabled = false;
                      else this.basicSettings.ssidPasswordEnabled = true;
                      break;
                  }
                }
              }
            }
          }
        });
    },
    dataFormat: helper.dataFormat,
    timeFormat: helper.timeFormat,
    GetTotalUserinXDays: function(days) {
      var nasid = this.selectedLocation.nasid;
      axios
        .get("/wiom/getdevicestats?nases=" + nasid + "&days=" + days)
        .then(response => {
          //console.log("get total users in" + days + "days");
          this.reportData.totalUsers = response.data.data.usersInXDays[nasid];
          this.reportData.reportsTotalUsers =
            response.data.data.usersInXDays[nasid];
        });
    },
    GetTotalDataInXDays: function(days) {
      var nasid = this.selectedLocation.nasid;
      axios
        .get("/wiom/getdevicestats?nases=" + nasid + "&days=" + days)
        .then(response => {
          //console.log(response);
          let totalData =
            response.data.data.dataUsed[nasid] == null
              ? 0
              : response.data.data.dataUsed[nasid];
          this.reportData.totalDataUsed = totalData.toFixed(2);
        });
    },
    GoToPaymentPage(){
      window.open(`https://wiom.in/wiompayment/subscriptions?pid=10004&nasid=${this.selectedLocation.nasid}`);
    },
    GetUsers: function() {
      let toDate = new Date();
      toDate.setDate(toDate.getDate() + 1);
      WIOM_APIS.getUsers({
        user : {
          nasid: this.selectedLocation.nasid,
          extraData: 'wiom_dashboard'
        },
        fromDate: (new Date(this.cumulatedData.from)).toGMTString(),
        toDate: toDate.toGMTString(),
      }).then(response => {
          let userArray = response.data;
          this.doneRegisteredUser = [];
          this.pendingRegisterUser = [];
          this.couponUsers = [];
          if (userArray && userArray.length) {
            let today = new Date();
            today.setHours(0,0,0,0);
            userArray.forEach(user => {
              user.extraData = user.extraDataObject || {};
              user.planStartTime && (user.planStartTime = new Date(user.planStartTime));
              user.otpExpiryTime && (user.otpExpiryTime = new Date(user.otpExpiryTime));
              if(user.otp != 'CASH_REJECTED' && user.status != 'rejected' && user.status != 'deleted' ) {
                if(user.mobile && user.mobile.trim()) {
                  if(user.otp != 'DIYBuyer') {
                    if(user.otp == 'PAY_ONLINE' || user.otp == "CASH") {
                      if(user.planStartTime.getTime() >= today.getTime())
                        this.pendingRegisterUser.push(user);
                    }
                    else if(user.mobile)
                      this.doneRegisteredUser.push(user);
                  }
                } else if(user.extraData.sent_to) {
                  this.couponUsers.push(user);
                }
              }
            });
            this.pendingRegisterUser.sort((a ,b) => {
                return b.planStartTime.getTime() - a.planStartTime.getTime();
            })
            this.doneRegisteredUser = this.doneRegisteredUser.sort((a ,b) => {
              return b.planStartTime.getTime() - a.planStartTime.getTime();
            })
            this.couponUsers.sort((a ,b) => {
              return b.planStartTime.getTime() - a.planStartTime.getTime();
            })
          }
          this.doneRegisteredUser.forEach(user => {
            if(user.planStartTime > this.cumulatedData.from) {
              console.log('adding')
              this.cumulatedData.earning += parseInt(user.charges);
              this.cumulatedData.requests += 1;
            } else
              console.log('not adding')
          });
        });
    },
    GetConnectionStatusAndTime: function() {
      var nasid = this.selectedLocation.nasid;
      //console.log(`GetDeviceStats called for ${nasid} from ${where}`);
      axios
        .get("/wiom/getdevicestats?nases=" + nasid + "&days=1")
        .then(response => {
          // console.log(response);
          let time = (
            parseInt(response.data.data.lastLoginTime[nasid]) / 60
          ).toFixed(2);
          if (time < 1) {
            this.reportData.connectionTime = time + "min";
          } else {
            this.reportData.connectionTime = time + "hrs";
          }
          this.reportData.connectionStatus =
            response.data.data.connectionStatus[nasid].status;
        });
    },
    updateCumuilativeData: function(options) {
      options = options || {
        text: 'Today'
      }
      let d = new Date();
      switch(options.text) {
        case '7 days':
          options.minutes = 10080;
          break;
        case 'Last 30 days':
          options.minutes = 43200;
          break;
        default:
          options.minutes = d.getHours() * 60 + d.getMinutes();
          break;
      }

      d = new Date();
      this.cumulatedData = {
        text: options.text,
        from: d.setMinutes(d.getMinutes() - options.minutes),
        earning: 0,
        requests: 0
      }
      this.GetUsers();
      return this.cumulatedData;
    },
    getSessionText: function(value) {
      this.sessionItems.forEach(item => {
        if (value == item.value) {
          //console.log(value, item.text, item.value);
          return item.text;
        }
      });
    },
    getSessionIndex: function(value) {
      for (var index in this.sessionValues) {
        if (value == this.sessionValues[index]) return index;
      }
      return null;
    },
    getDatalimitIndex: function(value) {
      for (var index in this.datalimitValues) {
        if (value == this.datalimitValues[index]) return index;
      }
      return null;
    },
    getNasDatalimitIndex: function(value) {
      for (var index in this.nasDatalimitValues) {
        if (value == this.nasDatalimitValues[index]) return index;
      }
      return null;
    },
    GetUserBasicConfig: function() {
      let that = this;
      WIOM_APIS.getUserBasicConfig(this.settingId)
        .then(response => {
          let bc = response.data.basicConfigs;
          that.basicSettings.maxDataPerDay = null;
          if (bc.CHILLISPOT_MAX_TOTAL_OCTETS.value || bc.CHILLISPOT_MAX_TOTAL_OCTETS.value == "")
            that.dataLimit = that.getDatalimitIndex(bc.CHILLISPOT_MAX_TOTAL_OCTETS.value);
          that.sessionTimeOut = that.getSessionIndex(bc.SESSION_TIMEOUT.value);
          that.basicSettings.maxDataConfigType =
            bc.CHILLISPOT_MAX_TOTAL_OCTETS.configType;
          that.basicSettings.sessionConfigType =
            bc.SESSION_TIMEOUT.configType;
        });
    },
    refreshUsage: function() {
      this.GetConnectionStatusAndTime("refresh usage");
    },
    refreshCustomers: function() {
      this.updateCumuilativeData({text: 'Today'});
    },
    refreshSettings: function() {
      this.GetUserBasicConfig();
      this.GetAdvancedSettings();
      this.GetDataPlanSettings();
    },
    ShowMaxDataDialog: function() {
      this.showMaxDataDialog = true;
    },
    ShowMaxTimeDialog: function() {
      this.showMaxTimeDialog = true;
    },
    ShowMaxDeviceDialog: function() {
      this.showMaxDeviceDialog = false;
    },
    showAdvancedSettingsError: function(msg) {
      this.bottomPopup.type = "error";
      this.bottomPopup.text = msg;
      this.bottomPopup.visible = true;
    },
    saveConfig: function() {
      let that = this;
      if (!this.nonPremium() && this.nasDataLimit < this.dataLimit) {
        this.showDataSettingWarning = true;
      } else {
        async.parallel([
            this.SetUserBasicConfig,
            this.SaveAdvancedSettings,
            this.SetAdvancedConfiguration,
        ], function (err, result) {
          if (!err && result) {
            console.log("Save Config Success", result);
            that.popup.type = "success";
            that.popup.text = "Settings Saved Successfully!";
            that.popup.visible = true;
          } else {
            console.log("Save Config Error", err);
            that.popup.type = "error";
            that.popup.text = "Error Saving Settings";
            that.popup.visible = true;
          }
        });
      }
    },
    upgrade: function() {
      this.showPlans = true;
    },
    EditSsidPassword: function() {},
    isSsidPasswordEnabled: function() {},
    showPasswordWarning: function() {
      console.log("Enabled->", this.basicSettings.ssidPasswordEnabled);

      if (this.basicSettings.ssidPasswordEnabled) {
        this.showPasswordPopup = true;
      } else {
        console.log("disabling");
        this.basicSettings.ssidPasswordEnabled = false;
        this.basicSettings.ssidPassword = null;
        this.showPasswordPopup = false;
      }
    },
    planNPayMethod: function(options) {
      this.planNPayPage =  options.page;
      this.editUpi = options.editUpi || false;
      this.planNPayOn = true;
    }
  },
  mounted: function() {
    if (this.settingId) {
      this.GetUserBasicConfig();
      this.GetConnectionStatusAndTime("mounted");
      this.GetAdvancedSettings();
    }
    this.reportData.userDuration = "Today";
    this.reportData.dataDuration = "Today";
    this.GetTotalUserinXDays(1);
    this.GetTotalDataInXDays(1);
    if(this.selectedLocation) {
      this.GetDataPlanSettings();
      this.tab = 0;
      if (this.selectTab)
      switch(this.selectTab) {
        case "usage":
          this.refreshUsage();
          this.tab = 0;
          break;
        case "customers":
          this.refreshCustomers();
          this.tab = 1;
          break;
        case "settings":
          this.refreshSettings();
          this.tab = 2;
          break;
        default:
          this.refreshUsage();
          this.tab = 0;
          break;
      }
    }
  },
  watch: {
    selectedLocation: function() {
      //console.log("selected location updated " + this.selectedLocation.nasid);
      this.GetUserBasicConfig();
      this.GetConnectionStatusAndTime("watch");
      this.GetAdvancedSettings();
      this.GetDataPlanSettings();

    },
    settingId: function() {
      //console.log("settingid updated");
      this.GetAdvancedSettings();
    }
  }
};
</script>
<style lang="scss">
.v-dialog--fullscreen {
  left: unset;
  max-width: 640px;
}
.lh-20 {
  line-height: 1.25rem !important;
}
.color-7d7d7d {
  color: #7d7d7d;
}
.btn-gredient {
  background: linear-gradient(#f4693a,#ef4f82);
}
.bg-green{
  background: #68d391 !important;
  p {
    color: white;
  }
}
.boxshadow{
  box-shadow: 0 0 6px rgb(0 0 0 / 16%) !important;
}
.header {
  background: rgb(33, 66, 148);
  padding: 1em;
  font-size: 0.75em;
  ul {
    padding: 0;
    .customer-record {
      margin-bottom: 0;
      span {
        color: white;
        &:nth-child(4){
          height: unset;
        }
      }
    }
  }
}
.customer-record {
  display: flex;
  margin-bottom: 0.5em;
  justify-content: space-between;
  cursor: pointer;
  font-size: 0.75em;
  span, strong {
    margin: auto 0;
    min-width: 6em;
    &:not(:last-child) {
      text-align: center;
    }
    &:nth-child(2) {
      min-width: 2.3rem;
    }
    &:nth-child(4) {
      min-width: 2.3rem;
      height: 1.5rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-around;
      img {
        margin-left: 0.2rem;
      }
    }
    &:last-child {
      text-align: end;
      min-width: 2em;
      button {
        width: 56px;
        span {
          font-size: 1em;
        }
      }
    }
  }
  .v-icon {
    font-size: 1.5em;
  }
}

.customer-container {
  font-size: 100%;
}
@media only screen and (max-width: 370px) and (min-width: 331px){
  .customer-container {
    font-size: 95%;
  }
}
@media only screen and (max-width: 330px) {
  .customer-container {
    font-size: 90%;
  }
}
</style>
